import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { CMAccountListItem, CurrentUserDetails } from 'services/apiService';
import { Await } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import SwitchCmAccountForm from './SwitchCmAccountForm';

const SwitchCmAccount = () => {
    const loaderData = useLoaderData() as {
        data: Promise<[CurrentUserDetails, CMAccountListItem[]]>;
    };

    return (
        // Loading indicator while fetching stats data
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading CM Account...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.data}
                errorElement={<p>Error while loading CM Account</p>}
            >
                <Typography variant='h5'>Switch CM Account</Typography>
                <br />
                <SwitchCmAccountForm />
            </Await>
        </React.Suspense>
    )
};

export default SwitchCmAccount;